import gql from 'graphql-tag';

const FRAGMENT = gql`
  fragment Popup on show_popup_referral {
    id
    user_id
    popup_date
    created_at
    popup_type
    wait_days
  }
`;

export const GET_REFERRAL_POPUP_DATE = gql`
  query getReferralPopupData($type: String) {
    show_popup_referral(where: { popup_type: { _eq: $type } }) {
      ...Popup
    }
  }
  ${FRAGMENT}
`;

export const UPSERT_REFERRAL_POPUP = gql`
  mutation popupreferral($user_id: Int!, $type: String! $waitDays: Int!, $popup_date: timestamptz) {
    insert_show_popup_referral(
      objects: { user_id: $user_id, popup_date: $popup_date, popup_type: $type, wait_days: $waitDays }
      on_conflict: {
        constraint: show_popup_referral_user_id_popup_type_key
        update_columns: [popup_date, wait_days]
      }
    ) {
      returning {
        ...Popup
      }
    }
  }
  ${FRAGMENT}
`;
